export const ROOT = 'root';
export const ROOT_ID = `#${ROOT}`;
